import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import BrandIntro from './components/BrandIntro';
import ProductSeries from './components/ProductSeries';
import HealthValues from './components/HealthValues';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '昆仑雪',
  alternateName: 'Kunlun Snow',
  url: 'https://kunlunsnow.com',
  description: '昆仑雪，汲取昆仑山万年冰川雪水精华，以极致纯净为核心理念的高端矿泉水品牌。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://kunlunsnow.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '昆仑雪',
  alternateName: 'Kunlun Snow',
  url: 'https://kunlunsnow.com',
  description: '中国高端矿泉水品牌，源自昆仑山万年冰川雪水。',
  foundingDate: '2012',
  areaServed: '全球',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-9999',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: '和田地区',
    addressRegion: '新疆维吾尔自治区',
    addressCountry: 'CN',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="源自雪山的纯净力量"
        description="昆仑雪，汲取昆仑山万年冰川雪水精华，以极致纯净为核心理念，为您带来来自世界屋脊的天然馈赠。探索品牌故事、产品系列与健康价值。"
        keywords="昆仑雪,昆仑山雪水,天然冰川水,纯净饮用水,昆仑雪品牌,高端矿泉水,雪山水源"
        canonicalUrl="https://kunlunsnow.com"
      />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <main>
        <HeroSection />
        <BrandIntro />
        <ProductSeries />
        <HealthValues />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}